import * as React from 'react';

import { push } from 'connected-react-router';
// import equal from 'fast-deep-equal';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { commonHandleShowErrorMessage } from 'src/actions/common';

import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloseIcon from '@material-ui/icons/Close';

import { Routes, Screens } from 'src/utils/Routes';
import ProgressLoading from '../components/Progress';

import {
	clearELearning,
	clearELearningReservedTreeItem,
	elearningComponentUpdated,
	ELearningKind,
	getScoringButtonClickResult,
	IIndexTreeItem,
	issueELearningReservedTreeItem,
	openELearningIndexTree,
	resetELearningPage,
	setELearningNextOrTopITem,
	setELearningPage,
	setELearningReservedTreeItem,
	setELearningTreeItem,
	setNextBtnDisFlg,
	setNotMarkCompleteFlg,
	setProgressLoadingFlg,
	setShowTree,
	showELearningByBookmark,
	showELearningFinishDialog,
} from '../actions/eLearning';

import { IELearningPushState } from 'src/pages/ELearning';
import ScenarioFactory, {
	IFetchELearningProgressParam,
	IFetchELearningTopParam,
	IFetchELearningTreeParam,
	INextTreeParam,
	IStartELearningTextParam,
} from 'src/scenario/ELearningScenarioFactory';
import { clearImstat } from '../actions/imstat';
import ExerciseForm from '../containers/ExerciseForm';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import { isMobile } from '../utils/MobileCheck';
import ScormAPIS from '../utils/ScormAPI';
import { funcClose } from '../utils/StartupUtils';
import EBar from './EBar';
import ELearningOutline from './ELearningOutline';
import ELearningQuestionnaire from './ELearningQuestionnaire';
import ELearningScorm from './ELearningScorm';
import { ELearningTerminal } from './ELearningTerminal';
import ELearningTestForm from './ELearningTestForm';
import ELearningTestResult from './ELearningTestResult';
import ELearningText from './ELearningText';
import IndexTree from './IndexTree';
const styles = (theme: Theme) =>
	createStyles({
		buttonBack: {
			bottom: theme.spacing(2),
			left: theme.spacing(2),
			position: 'fixed',
		},
		buttonForward: {
			bottom: theme.spacing(2),
			position: 'fixed',
			right: theme.spacing(2),
		},
		root: {
			backgroundColor: '#fff',
			transition: 'width 2s',
		},
	});

export interface IELearningCommonProps {
	careerID: string;
	classID: string;
	outOfPeriodFlg: boolean;
	preview: boolean;
	windowId?: string;
}

interface IState {
	resumeConfirmed: boolean;
	openNavigationTopic: boolean;
	openNavigationTest: boolean;
	navigationConfirmed: boolean;
	openCannotMoveItem: boolean;
	playerStatus: boolean;
	currentItemID: string | null;
	jumpScreenMessage: boolean;
	messageContent: string;
	messageTitle: string;
	currentItem: IIndexTreeItem | null;
	nextItem: IIndexTreeItem | null;
	prevItem: IIndexTreeItem | null;
	outLineFlg: boolean;
	expiredDialog: boolean;
	openNoticeGridQuestionnaire: boolean;
	openNoticeExercise: boolean;
	openNextPageConfirm: boolean;
	openPrevPageConfirm: boolean;
}

/**
 * 最終ページ用Index固定値
 */
const terminal: IIndexTreeItem = {
	answerPeriod: '',
	children: null,
	cnt: -1,
	completeFlg: false,
	disableFlg: false,
	displayStyle: -1,
	enqueteType: '1',
	expired: false,
	hintList: null,
	iconClass: '',
	id: '@@LAST',
	indexNo: Number.MAX_SAFE_INTEGER,
	kind: ELearningKind.TERMINAL,
	notMarkFlg: true,
	page: 0,
	pageCount: 1,
	requiredFlg: false,
	retries: -1,
	scoType: null,
	seqNo: -1,
	testID: null,
	testTitle: null,
	text: 'test',
	timeLimit: -1,
	userBookMark: -1,
};

/**
 * eラーニングの親コンポーネント
 */
export class ELearningComponent extends React.Component<IProps, IState> {
	/**
	 * Lifecycle Methods
	 */
	public static getDerivedStateFromProps(
		nextProps: IProps,
		prevState: IState
	) {
		const state = {} as any;

		const nextItemID = nextProps.currentTreeItem
			? nextProps.currentTreeItem.id
			: null;
		if (prevState.currentItemID !== nextItemID) {
			// ページ遷移した
			state.currentItemID = nextItemID;
			state.playerStatus = false;
		}
		return state;
	}
	protected elTestForm: any;
	protected elQuestionForm: any;

	constructor(props: IProps) {
		super(props);
		this.state = {
			currentItem: null,
			currentItemID: null,
			expiredDialog: false,
			jumpScreenMessage: false,
			messageContent: '',
			messageTitle: '',
			navigationConfirmed: false,
			nextItem: null,
			openCannotMoveItem: false,
			openNavigationTest: false,
			openNavigationTopic: false,
			openNextPageConfirm: false,
			openNoticeExercise: false,
			openNoticeGridQuestionnaire: false,
			openPrevPageConfirm: false,
			outLineFlg: false,
			playerStatus: false,
			prevItem: null,
			resumeConfirmed: false,
		};

		this.closeDialog = this.closeDialog.bind(this);
		this.fetchELearningProgress = this.fetchELearningProgress.bind(this);
		this.handleNextQuestion = this.handleNextQuestion.bind(this);
		this.handlePrevQuestion = this.handlePrevQuestion.bind(this);

		this.Dialogs.displayName = 'Dialogs';
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		const {
			careerID,
			classID,
			outOfPeriodFlg,
			state,
			pushHistory,
			preview,
		} = this.props;

		// 実施状況の初期化
		this.props.clearImstat();

		// TopBlockデータ取得
		this.props
			.fetchELearningTop(this.props.token, {
				careerID,
				classID,
				isPreview: this.props.preview,
				userId: this.props.userAttr.userId,
			})
			.catch(e => {
				if (localStorage.getItem('portalFlg') === '0') {
					return;
				}
				// 前画面に戻る
				const caller =
					state && state.caller
						? state.caller
						: Routes.getPath(Screens.PERSONAL_PORTAL);
				pushHistory(caller);
			});
		if ((state && state.showTree) || outOfPeriodFlg || preview) {
			this.props.openELearningIndexTree();
		} else {
			this.props.fetchELearningTree(this.props.token, {
				careerID,
				classID,
				isPreview: this.props.preview,
				userAttr: this.props.userAttr,
			});
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearELearning();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.isFirst !== 1 && this.props.isFirst === 1) {
			this.props.openELearningIndexTree();
		}

		// if (!equal(prevProps.currentTreeItem, this.props.currentTreeItem)) {
		// current-item has been changed
		// 目次遷移時にアクション発行
		const {
			careerID,
			classID,
			preview: isPreview,
			userAttr: { userId },
		} = this.props;

		this.props.updated({
			next: this.props.currentTreeItem,
			previous: prevProps.currentTreeItem,
			progress: {
				careerID,
				classID,
				isPreview,
				userId,
			},
		});
		// }
	}

	public render() {
		const {
			classes,
			currentTreeItem,
			careerID,
			classID,
			outOfPeriodFlg,
			preview,
			reservedTreeItem,
		} = this.props;

		if (this.state.outLineFlg) {
			this.handleNextConfirm();
		}
		if (
			!this.state.resumeConfirmed &&
			this.props.mapParam.completion === 0 &&
			this.props.isFirst === 0
		) {
			this.props.openELearningIndexTree();
		}
		const state = this.props.state;
		const caller =
			state && state.caller
				? state.caller
				: Routes.getPath(Screens.PERSONAL_PORTAL);
		const content = !currentTreeItem
			? null
			: (() => {
					switch (currentTreeItem.kind) {
						case ELearningKind.OUTLINE:
							return (
								<ELearningOutline
									careerID={careerID}
									classID={classID}
									outOfPeriodFlg={outOfPeriodFlg}
									preview={preview}
								/>
							);
						case ELearningKind.TEXT:
							return (
								<ELearningText
									careerID={careerID}
									classID={classID}
									outOfPeriodFlg={outOfPeriodFlg}
									onChangePlayerStatus={
										this.handleChangePlayerStatus
									}
									preview={preview}
									handleShowIndexTree={
										this.props.openELearningIndexTree
									}
									caller={caller}
									handlePrevQuestion={this.handlePrevQuestion}
									handleNextQuestion={this.handleNextQuestion}
									disabledPrev={this.isValidPrev()}
									disabledNext={this.isValidNext()}
									setProgressLoadingFlg={
										this.props.setProgressLoadingFlg
									}
								/>
							);
						case ELearningKind.TESTLOG:
							return (
								<ELearningTestResult
									careerID={careerID}
									classID={classID}
									outOfPeriodFlg={outOfPeriodFlg}
									preview={preview}
								/>
							);
						case ELearningKind.SCORM:
							return (
								<ELearningScorm
									careerID={careerID}
									classID={classID}
									outOfPeriodFlg={outOfPeriodFlg}
									preview={preview}
									updateProgress={this.fetchELearningProgress}
								/>
							);
						case ELearningKind.ENQUETE:
							const flg =
								currentTreeItem.iconClass === 'enquete-complete'
									? 1
									: 0;
							return (
								<ELearningQuestionnaire
									accessFlg={1}
									careerID={careerID}
									classID={classID}
									handlePrev={this.handlePrev}
									handleNext={this.handleNext}
									onRef={this.onQuRef}
									outOfPeriodFlg={outOfPeriodFlg}
									preview={preview}
									flg={flg}
									updateState={this.updateState}
								/>
							);
						case ELearningKind.SUBJECT:
							const subjectStatusflg =
								currentTreeItem.kind === 5 &&
								currentTreeItem.subjectText === '2'
									? '1'
									: '0';
							return (
								<ExerciseForm
									careerID={careerID}
									classID={classID}
									outOfPeriodFlg={outOfPeriodFlg}
									seq={currentTreeItem.indexNo.toString()}
									preview={preview}
									flg={1}
									subjectStatusflg={subjectStatusflg}
								/>
							);
						case ELearningKind.TEST:
							return (
								<ELearningTestForm
									careerID={careerID}
									classID={classID}
									outOfPeriodFlg={outOfPeriodFlg}
									preview={preview}
									getNextTreeItem={
										this.getNextTreeItemToTestForm
									}
									handlePrev={this.handlePrev}
									handleNext={this.handleNext}
									onRef={this.onRef}
									updateState={this.updateState}
									setProgressLoadingFlg={
										this.props.setProgressLoadingFlg
									}
								/>
							);
						case ELearningKind.TERMINAL:
							// 終端処理
							return (
								<ELearningTerminal
									careerId={careerID}
									classId={classID}
									isPreview={preview}
									handleChangePlayerStatus={
										this.handleChangePlayerStatus
									}
								/>
							);
						case ELearningKind.TITLE:
						case ELearningKind.SCORM_TITLE:
						case ELearningKind.SCORM_TEST_LOG:
							// clarify noop
							return null;
						default:
							const exhaustive: never = currentTreeItem.kind; // must be never
							throw exhaustive;
					}
			  })();

		const main = !content ? null : (
			<React.Fragment>
				{content}
				<Fab
					color="primary"
					aria-label="left"
					className={classes.buttonBack}
					onClick={this.handlePrevQuestion}
					disabled={!this.isValidPrev()}
				>
					<ArrowBackIcon />
				</Fab>
				<Fab
					color="primary"
					aria-label="right"
					className={classes.buttonForward}
					onClick={this.handleNextQuestion}
					disabled={!this.isValidNext() || this.props.nextBtnDisFlg}
				>
					<ArrowForwardIcon />
				</Fab>
			</React.Fragment>
		);

		let testConfirm: JSX.Element | null = null;
		if (reservedTreeItem && !this.props.outOfPeriodFlg) {
			if (
				reservedTreeItem.retries !== 0 &&
				reservedTreeItem.cnt >= reservedTreeItem.retries
			) {
				// 受講回数超え
				const { testTitle, cnt } = reservedTreeItem;
				const retries = reservedTreeItem.retries
					? reservedTreeItem.retries + i18n.t('Elearning_0001')
					: i18n.t('Elearning_0002');
				const timeLimit = reservedTreeItem.timeLimit
					? reservedTreeItem.timeLimit + i18n.t('Elearning_0003')
					: i18n.t('Elearning_0002');
				const message = i18n.t('Elearning_0004', {
					cnt,
					retries,
					testTitle,
					timeLimit,
				});
				testConfirm = (
					<Snackbar
						anchorOrigin={{
							horizontal: 'left',
							vertical: 'bottom',
						}}
						open={reservedTreeItem ? true : false}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						ContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span>{message}</span>}
						action={
							<IconButton
								key="close"
								aria-label="Close"
								color="inherit"
								onClick={this.handleCloseSnackbar}
							>
								<CloseIcon />
							</IconButton>
						}
					/>
				);
			} else {
				testConfirm = (
					<TestConfirm
						item={reservedTreeItem}
						handleStart={this.handleStartTest}
						handleClose={this.handleCloseConfirmTest}
						handleShowIndexTree={this.handleShowIndexTree}
						handleFinishELearning={this.handleFinishELearning}
						showTree={this.props.showTree}
					/>
				);
			}
		}

		return (
			<div className={classes.root}>
				<ProgressLoading open={this.props.progressLoadingFlg} />
				<IndexTree
					careerID={careerID}
					classID={classID}
					preview={preview}
					windowId={this.props.windowId}
				/>
				<EBar
					careerID={careerID}
					classID={classID}
					caller={caller}
					preview={preview}
				/>
				{main}
				{testConfirm}

				<this.Dialogs />
			</div>
		);
	}

	protected onRef = (view: object) => {
		this.elTestForm = view;
	};

	protected onQuRef = (view: object) => {
		this.elQuestionForm = view;
	};
	protected Dialogs: React.FC = () => {
		return (
			<>
				<Dialog
					open={
						!this.state.resumeConfirmed &&
						this.props.mapParam.completion === 0 &&
						this.props.isFirst === 0 &&
						this.props.requiredItemFlg === true
					}
					onClose={this.handleCloseConfirmResume}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('Elearning_0006')} <br />
							{i18n.t('Elearning_0007')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleResume} color="primary">
							{i18n.t('Elearning_0008')}
						</Button>
						<Button
							onClick={this.handleCloseConfirmResume}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={
						!this.state.resumeConfirmed &&
						this.props.mapParam.completion === 0 &&
						this.props.isFirst === 0 &&
						this.props.requiredItemFlg === false
					}
					onClose={this.handleCloseConfirmResume}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle>{i18n.t('Elearning_0005')}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('IndexTree_0018')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseConfirmResume}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={
						!this.state.resumeConfirmed &&
						this.props.mapParam.completion === 1 &&
						this.props.preview === false &&
						!(
							this.props.resumeTopic === null ||
							this.props.resumeTopic === ''
						)
					}
					onClose={this.handleCloseFinishDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('Elearning_0010')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowIndexTree}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
						<Button
							onClick={this.handleFinishELearning}
							color="primary"
						>
							{i18n.t('Elearning_0011')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog open={this.state.openNavigationTopic}>
					<DialogTitle>{i18n.t('Elearning_0005')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('Elearning_0012')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowOutline}
							color="primary"
						>
							{i18n.t('Elearning_0013')}
						</Button>
						<Button
							onClick={this.handleSkipOutline}
							color="primary"
						>
							{i18n.t('Elearning_0014')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog open={this.state.openNavigationTest}>
					<DialogTitle>{i18n.t('Elearning_0005')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('Elearning_0015')}
							<br />
							{i18n.t('Elearning_0016')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowOutline}
							color="primary"
						>
							{i18n.t('Elearning_0013')}
						</Button>
						<Button
							onClick={this.handleSkipOutline}
							color="primary"
						>
							{i18n.t('Elearning_0017')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openCannotMoveItem}
					onClose={this.handleCloseCannotMoveItem}
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="cannot-move-item">
							{i18n.t('Elearning_0018')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseCannotMoveItem}
							color="primary"
						>
							{i18n.t('Elearning_0019')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={
						this.props.showFinishDialog &&
						this.props.mapParam.completion === 0 &&
						this.props.preview === false &&
						this.props.requiredItemFlg === true
					}
					onClose={this.handleCloseFinishDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{this.props.markAfter
								? i18n.t('Elearning_0020')
								: i18n.t('Elearning_0006')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowIndexTree}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
						<Button
							onClick={this.handleFinishELearning}
							color="primary"
						>
							{i18n.t('Elearning_0011')}
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={
						this.props.showFinishDialog &&
						this.props.mapParam.completion === 0 &&
						this.props.preview === false &&
						this.props.requiredItemFlg === false
					}
					onClose={this.handleCloseFinishDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{this.props.markAfter
								? i18n.t('Elearning_0020')
								: i18n.t('Elearning_0048')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowIndexTree}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
						<Button
							onClick={this.handleFinishELearning}
							color="primary"
						>
							{i18n.t('Elearning_0011')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={
						this.props.showFinishDialog &&
						this.props.mapParam.completion === 1 &&
						this.props.preview === false
					}
					onClose={this.handleCloseFinishDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('Elearning_0010')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowIndexTree}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
						<Button
							onClick={this.handleFinishELearning}
							color="primary"
						>
							{i18n.t('Elearning_0011')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={
						this.props.showFinishDialog &&
						this.props.preview === true
					}
					onClose={this.handleCloseFinishDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('Elearning_0021')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowIndexTree}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
						<Button
							onClick={this.handleFinishELearning}
							color="primary"
						>
							{i18n.t('Elearning_0011')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.jumpScreenMessage}
					onClose={this.closeDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{this.state.messageContent} <br />
							{this.state.messageTitle}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleNextConfirm}
							color="primary"
						>
							{i18n.t('Elearning_0019')}
						</Button>
						<Button
							onClick={this.handleShowIndexTree}
							color="primary"
						>
							{i18n.t('Elearning_0022')}
						</Button>
						<Button
							onClick={this.handleFinishELearning}
							color="primary"
						>
							{i18n.t('Elearning_0011')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.expiredDialog}
					onClose={this.closeDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="cannot-move-item">
						{i18n.t('Elearning_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('Elearning_0023')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleShowIndexTree}
							color="primary"
						>
							{i18n.t('Elearning_0009')}
						</Button>
						<Button
							onClick={this.handleFinishELearning}
							color="primary"
						>
							{i18n.t('Elearning_0011')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openNoticeGridQuestionnaire}
					onClose={this.handleCloseNoticeGridQuestionnaire}
				>
					<DialogTitle>{i18n.t('Elearning_0040')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('Elearning_0041')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseNoticeGridQuestionnaire}
							color="primary"
						>
							{i18n.t('Elearning_0019')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openNoticeExercise}
					onClose={this.handleCloseNoticeExercise}
				>
					<DialogTitle>{i18n.t('Elearning_0040')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('Elearning_0042')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseNoticeExercise}
							color="primary"
						>
							{i18n.t('Elearning_0019')}
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog open={this.state.openPrevPageConfirm}>
					<DialogTitle>{i18n.t('Elearning_0005')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('Elearning_0043')}
							<br />
							{i18n.t('Elearning_0044')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handlePrevPageConfirm}
							color="primary"
						>
							{i18n.t('Elearning_0045')}
						</Button>
						<Button
							onClick={this.handlePrevPageConfirmCancel}
							color="primary"
						>
							{i18n.t('Elearning_0046')}
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog open={this.state.openNextPageConfirm}>
					<DialogTitle>{i18n.t('Elearning_0005')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('Elearning_0043')}
							<br />
							{i18n.t('Elearning_0044')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleNextPageConfirm}
							color="primary"
						>
							{i18n.t('Elearning_0045')}
						</Button>
						<Button
							onClick={this.handleNextPageConfirmCancel}
							color="primary"
						>
							{i18n.t('Elearning_0046')}
						</Button>
					</DialogActions>
				</Dialog>
			</>
		);
	};

	protected closeDialog() {
		this.setState({
			expiredDialog: false,
			jumpScreenMessage: false,
		});
	}

	/**
	 * 戻るボタンが表示可能か
	 */
	protected isValidPrev() {
		const item = this.props.currentTreeItem;
		if (!item || item.disableFlg) {
			return false;
		}
		if (
			item.enqueteType === '3' &&
			this.getPrevTreeItem() === null &&
			this.elQuestionForm !== undefined
		) {
			if (!this.elQuestionForm.preBtnDisabled) {
				return true;
			}
		}

		if (
			item.kind === 3 &&
			this.getPrevTreeItem() === null &&
			this.elTestForm !== undefined
		) {
			if (!this.elTestForm.preBtnDisabled) {
				return true;
			}
		}

		if (
			item.kind === ELearningKind.OUTLINE ||
			item.kind === ELearningKind.TEXT
		) {
			if (this.props.currentPage !== 1) {
				return true;
			}
		}
		return this.getPrevTreeItem() ? true : false;
	}

	/**
	 * 戻るナビゲーション押下時ハンドラ
	 */
	protected handlePrev = () => {
		const item = this.props.currentTreeItem as IIndexTreeItem;

		if (
			item.kind === ELearningKind.ENQUETE ||
			(item.kind === ELearningKind.TEST && !this.props.notMarkCompleteFlg)
		) {
			// テスト・アンケートから他のトピックに移動する場合、確認メッセージを表示
			this.setState({ openPrevPageConfirm: true });
			return;
		} else {
			// その他場合、前トピックを遷移
			this.props.setNotMarkCompleteFlg();
			this.toPrevPage();
		}
	};

	/**
	 * 次へボタンが表示可能か
	 */
	protected isValidNext() {
		return !this.state.playerStatus;
	}

	protected updateState = () => {
		this.setState({});
	};

	protected handleNextQuestion = async () => {
		const item = this.props.currentTreeItem as IIndexTreeItem;
		// テキスト遷移開始時、次へボタンが無効化
		if (item.kind === ELearningKind.TEXT && !this.props.preview) {
			this.props.setNextBtnDisFlg(true);
		}
		if (item.enqueteType === '3') {
			this.elQuestionForm.handleNext();
			this.setState({});
		} else if (item.kind === ELearningKind.TEST) {
			this.elTestForm.handleNext();
			this.setState({});
		} else if (
			item.kind === ELearningKind.TEXT &&
			!this.props.preview &&
			this.props.admintFlg === '1'
		) {
			// Admint動画修了判定
			await this.props
				.fetchAdmintCompleteModel(this.props.token, {
					careerID: this.props.careerID,
					classID: this.props.classID,
					isMenu: false,
					isPreview: this.props.preview,
					page: this.props.currentPage,
					pageCount: item.pageCount,
					topicID: item.id,
					userAttr: this.props.userAttr,
				})
				.then(data => {
					this.handleNext();
				})
				.catch(e => {
					// handle network error
					commonHandleShowErrorMessage({
						content: e.messageKey,
						replacements: [],
					});
					// Admintサーバ側が異常発生の場合、次へボタンを有効化
					this.props.setNextBtnDisFlg(false);
					return;
				});
		} else {
			this.handleNext();
		}
	};

	protected handlePrevQuestion = () => {
		const item = this.props.currentTreeItem as IIndexTreeItem;
		if (item.enqueteType === '3') {
			this.elQuestionForm.handlePrev();
			this.setState({});
		} else if (item.kind === ELearningKind.TEST) {
			this.elTestForm.handlePrev();
			this.setState({});
		} else {
			this.handlePrev();
		}
	};

	/**
	 * 次へナビゲーション押下時ハンドラ
	 */
	protected handleNext = () => {
		this.props
			.fetchELearningProgress(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				userId: this.props.userAttr.userId,
			})
			.then(() => {
				const item = this.props.currentTreeItem as IIndexTreeItem;
				if (
					item.kind === ELearningKind.ENQUETE ||
					(item.kind === ELearningKind.TEST &&
						!this.props.notMarkCompleteFlg)
				) {
					// テスト・アンケートから他のトピックに移動する場合、確認メッセージを表示
					this.setState({ openNextPageConfirm: true });
					return;
				} else {
					// その他場合、次トピックを遷移
					this.props.setNotMarkCompleteFlg();
					this.toNextPage();
				}
			})
			.catch(e => {
				// サーバ側が異常発生の場合、次へボタンを有効化
				this.props.setNextBtnDisFlg(false);
				throw e;
			});
	};

	protected handleNextConfirm = async () => {
		this.setState({ jumpScreenMessage: false, outLineFlg: false });
		if (this.state.nextItem) {
			if (
				isMobile() &&
				this.state.nextItem.kind === ELearningKind.ENQUETE &&
				this.state.nextItem.enqueteType === '2'
			) {
				this.setState({
					openNoticeGridQuestionnaire: true,
				});
			} else if (
				isMobile() &&
				this.state.nextItem.kind === ELearningKind.SUBJECT
			) {
				this.setState({
					openNoticeExercise: true,
				});
			} else {
				this.props.setELearningTreeItem(this.state.nextItem);
				if (
					this.state.currentItem &&
					this.state.currentItem.kind === ELearningKind.TEXT
				) {
					this.props.nextTree(this.props.token, {
						actionKind: 'next',
						careerID: this.props.careerID,
						startTime: this.props.startTime,
						topicID: this.state.currentItem.id,
						userAttr: this.props.userAttr,
					});
				}
			}
		} else if (this.state.prevItem) {
			if (
				isMobile() &&
				this.state.prevItem.kind === ELearningKind.ENQUETE &&
				this.state.prevItem.enqueteType === '2'
			) {
				this.setState({
					openNoticeGridQuestionnaire: true,
				});
			} else if (
				isMobile() &&
				this.state.prevItem.kind === ELearningKind.SUBJECT
			) {
				this.setState({
					openNoticeExercise: true,
				});
			} else {
				this.props.setELearningTreeItem(this.state.prevItem);
				await this.fetchELearningProgress();
				if (
					this.state.currentItem &&
					this.state.currentItem.kind === ELearningKind.TEXT
				) {
					this.props.nextTree(this.props.token, {
						actionKind: 'prev',
						careerID: this.props.careerID,
						startTime: this.props.startTime,
						topicID: this.state.currentItem.id,
						userAttr: this.props.userAttr,
					});
				}
			}
		}
	};

	/**
	 * レジュームハンドラ
	 */
	protected handleResume = () => {
		this.props.closeIndexTree();
		this.setState({ resumeConfirmed: true });
		let resumeAny = this.resumeIndexTree(
			this.props.indexTree
		) as IIndexTreeItem[];
		if (this.props.scorm && this.props.lastLocation) {
			this.props.showELearningByBookmark(
				this.props.lastLocation,
				this.props.resumePage
			);
		} else {
			// すべて修了の場合、課題承認のチェック
			if (resumeAny.length === 0) {
				resumeAny = this.resumeSubject(
					this.props.indexTree
				) as IIndexTreeItem[];
			}
			this.props.showELearningByBookmark(resumeAny[0].id, 1);
		}
	};
	/**
	 * 最初の未修了項目
	 */
	protected resumeIndexTree(indexTree: IIndexTreeItem[]) {
		const resume = [] as IIndexTreeItem[];
		for (const item of indexTree) {
			if (!item.expired && item.kind !== 0) {
				if (item.kind !== 1 && !item.completeFlg) {
					resume.push(item);
				}

				if (
					(item.kind === 1 && item.children) ||
					(item.kind === 2 && item.completeFlg && item.children)
				) {
					for (const child of this.resumeIndexTree(item.children)) {
						resume.push(child);
					}
				}
			}
		}
		return resume;
	}
	/**
	 * 課題承認のチェック
	 */
	protected resumeSubject(indexTree: IIndexTreeItem[]) {
		const resume = [] as IIndexTreeItem[];
		for (const item of indexTree) {
			// 課題のみが提出済みで未承認（未採点）の場合、課題へ遷移
			if (item.kind === 5 && item.subjectText === '2') {
				resume.push(item);
			}
		}
		return resume;
	}
	/**
	 * レジューム確認ダイアログクローズハンドラ
	 */
	protected handleCloseConfirmResume = () => {
		this.setState({ resumeConfirmed: true });
		this.props.openELearningIndexTree();
		this.props.setELearningTreeItem(null);
	};

	/**
	 * 前ページ遷移確認ダイアログから前ページへ遷移
	 */
	protected handlePrevPageConfirm = () => {
		this.setState({ openPrevPageConfirm: false });
		this.toPrevPage();
	};

	/**
	 * 前ページ遷移確認ダイアログクローズハンドラ
	 */
	protected handlePrevPageConfirmCancel = () => {
		this.setState({ openPrevPageConfirm: false });
	};

	/**
	 * 次ページ遷移確認ダイアログから次ページへ遷移
	 */
	protected handleNextPageConfirm = () => {
		this.setState({ openNextPageConfirm: false });
		this.toNextPage();
	};

	/**
	 * 次ページ遷移確認ダイアログクローズハンドラ
	 */
	protected handleNextPageConfirmCancel = () => {
		this.setState({ openNextPageConfirm: false });
	};

	/**
	 * 前ページへ遷移処理
	 */
	protected toPrevPage = () => {
		const item = this.props.currentTreeItem as IIndexTreeItem;

		if (
			item.kind === ELearningKind.OUTLINE ||
			item.kind === ELearningKind.TEXT
		) {
			// 概要かテキストでページ移動可能な場合はページ移動
			if (this.props.currentPage !== 1) {
				this.props.setELearningPage(this.props.currentPage - 1);
				return;
			}
		}

		const prev = this.getPrevTreeItem() as IIndexTreeItem;
		if (prev.kind === ELearningKind.TEST) {
			this.props.setELearningReservedTreeItem(prev);
			return;
		}

		if (prev.expired) {
			// 次アイテムが無効状態
			this.setState({ expiredDialog: true });
			this.props.openELearningIndexTree();
			return;
		}
		if (
			prev.kind === ELearningKind.ENQUETE ||
			prev.kind === ELearningKind.SUBJECT ||
			(prev.kind === ELearningKind.SCORM &&
				item.kind !== ELearningKind.SCORM) ||
			(prev.kind === ELearningKind.TEXT &&
				item.kind !== ELearningKind.TEXT) ||
			prev.kind === ELearningKind.OUTLINE
		) {
			this.setState({
				currentItem: item,
				nextItem: null,
				prevItem: prev,
			});
			switch (prev.kind) {
				case ELearningKind.ENQUETE:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0024'),
						messageTitle: i18n.t('Elearning_0025') + prev.text,
					});
					break;
				case ELearningKind.SUBJECT:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0026'),
						messageTitle: i18n.t('Elearning_0027') + prev.text,
					});
					break;
				case ELearningKind.TEXT:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0028'),
						messageTitle: i18n.t('Elearning_0029') + prev.text,
					});
					break;
				case ELearningKind.SCORM:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0030'),
						messageTitle: i18n.t('Elearning_0031') + prev.text,
					});
					break;
				case ELearningKind.OUTLINE:
					this.setState({
						outLineFlg: true,
					});
					break;
			}
			return;
		}

		this.props.setELearningTreeItem(prev);
		this.fetchELearningProgress();
		if (item.kind === ELearningKind.TEXT) {
			this.props.nextTree(this.props.token, {
				actionKind: 'prev',
				careerID: this.props.careerID,
				startTime: this.props.startTime,
				topicID: item.id,
				userAttr: this.props.userAttr,
			});
		}
	};

	/**
	 * 次ページへ遷移処理
	 */
	protected toNextPage = () => {
		const item = this.props.currentTreeItem as IIndexTreeItem;
		if (
			item.kind === ELearningKind.OUTLINE ||
			item.kind === ELearningKind.TEXT
		) {
			// 概要かテキストでページ移動可能な場合はページ移動
			if (this.props.currentPage !== item.pageCount) {
				this.props.setELearningPage(this.props.currentPage + 1);
				return;
			}
		}
		const next = this.getNextTreeItem() || terminal;
		if (!next) {
			// 最終ページ
			this.props.showELearningFinishDialog(true);
			return;
		}
		if (next.expired) {
			// 次アイテムが無効状態
			this.setState({ expiredDialog: true });
			this.props.openELearningIndexTree();
			// テキストに移動し、メッセージが表示する場合、次へボタンを有効化
			this.props.setNextBtnDisFlg(false);
			return;
		}
		if (next.disableFlg) {
			// 次アイテムが無効状態
			this.setState({ openCannotMoveItem: true });
			// テキストに移動し、メッセージが表示する場合、次へボタンを有効化
			this.props.setNextBtnDisFlg(false);
			return;
		}
		if (next.kind === ELearningKind.TEST) {
			this.props.setELearningReservedTreeItem(next);
			// テキストからテストに移動し、次へボタンを有効化
			this.props.setNextBtnDisFlg(false);
			return;
		}
		if (
			next.kind === ELearningKind.ENQUETE ||
			next.kind === ELearningKind.SUBJECT ||
			(next.kind === ELearningKind.SCORM &&
				item.kind !== ELearningKind.SCORM) ||
			(next.kind === ELearningKind.TEXT &&
				item.kind !== ELearningKind.TEXT) ||
			next.kind === ELearningKind.OUTLINE
		) {
			this.setState({
				currentItem: item,
				nextItem: next,
				prevItem: null,
			});
			switch (next.kind) {
				case ELearningKind.ENQUETE:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0024'),
						messageTitle: i18n.t('Elearning_0025') + next.text,
					});
					break;
				case ELearningKind.SUBJECT:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0026'),
						messageTitle: i18n.t('Elearning_0027') + next.text,
					});
					break;
				case ELearningKind.TEXT:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0028'),
						messageTitle: i18n.t('Elearning_0029') + next.text,
					});
					break;
				case ELearningKind.SCORM:
					this.setState({
						jumpScreenMessage: true,
						messageContent: i18n.t('Elearning_0030'),
						messageTitle: i18n.t('Elearning_0031') + next.text,
					});
					break;
				case ELearningKind.OUTLINE:
					this.setState({
						outLineFlg: true,
					});
					break;
			}
			// テキストからアンケートなどに移動し、メッセージが表示する場合、次へボタンを有効化
			this.props.setNextBtnDisFlg(false);
			return;
		}
		this.props.setELearningTreeItem(next);
		if (item.kind === ELearningKind.TEXT) {
			this.props.nextTree(this.props.token, {
				actionKind: 'next',
				careerID: this.props.careerID,
				startTime: this.props.startTime,
				topicID: item.id,
				userAttr: this.props.userAttr,
			});
		}
	};

	/**
	 * テスト開始ハンドラ
	 */
	protected handleStartTest = () => {
		this.props.setShowTree(true);
		if (this.props.elearingUpdateResult) {
			this.props.clearELearningReservedTreeItem();
			this.props.setELearningNextOrTopITem();
		} else {
			this.props.issueELearningReservedTreeItem();
		}
		this.props.getScoringButtonClickResult(undefined);
	};

	/**
	 * テスト開始確認ダイアログクローズハンドラ
	 */
	protected handleCloseConfirmTest = () => {
		this.props.setShowTree(true);
		this.props.getScoringButtonClickResult(undefined);
		this.props.clearELearningReservedTreeItem();
		this.handleShowIndexTree();
		this.props.setELearningTreeItem(null);
		const { careerID, classID } = this.props;
		this.props.fetchELearningTree(this.props.token, {
			careerID,
			classID,
			isPreview: this.props.preview,
			userAttr: this.props.userAttr,
		});
	};

	/**
	 * スナックバー表示クローズハンドラ
	 */
	protected handleCloseSnackbar = () => {
		this.props.clearELearningReservedTreeItem();
	};

	/**
	 * 受講終了確認ダイアログクローズハンドラ
	 */
	protected handleCloseFinishDialog = () => {
		this.setState({
			resumeConfirmed: true,
		});
		this.props.showELearningFinishDialog(false);
	};

	/**
	 * 目次表示ハンドラ
	 */
	protected handleShowIndexTree = () => {
		this.setState({ resumeConfirmed: true });
		this.props.setShowTree(true);
		this.props.clearELearningReservedTreeItem();
		this.setState({ jumpScreenMessage: false, expiredDialog: false });
		this.props.showELearningFinishDialog(false);
		this.props.setELearningTreeItem(null);
		this.props.openELearningIndexTree();
	};

	/**
	 * 学習終了ハンドラ
	 */
	protected handleFinishELearning = () => {
		const portalFlg = localStorage.getItem('portalFlg');
		if (portalFlg === '0') {
			funcClose();
			return;
		}
		ScormAPIS.TelsFlashNavigation(this.props.scormApi);
		this.setState({ resumeConfirmed: true });
		this.props.setShowTree(true);
		this.props.showELearningFinishDialog(false);
		this.setState({ expiredDialog: false });

		if (this.props.preview) {
			// eラーニング閲覧のとき
			if (window.opener && window.opener.closed === false) {
				// 呼び出し元ウィンドウが生きている場合はそちらで処理してもらう
				window.opener.postMessage('endpreview', '*');
			}
			return;
		}

		const state = this.props.state;
		const caller =
			state && state.caller
				? state.caller
				: Routes.getPath(Screens.PERSONAL_PORTAL);
		this.props.pushHistory(caller);
	};

	/**
	 * 概要を読むハンドラ
	 */
	protected handleShowOutline = () => {
		this.setState({
			openNavigationTest: false,
			openNavigationTopic: false,
		});
		const serialized = this.serializeIndexTree(this.props.indexTree);
		for (const i of serialized) {
			if (i.kind === ELearningKind.OUTLINE) {
				this.props.setELearningTreeItem(i);
				break;
			}
		}
	};

	/**
	 * 学習を始めるハンドラ
	 */
	protected handleSkipOutline = () => {
		this.setState({
			openNavigationTest: false,
			openNavigationTopic: false,
		});
		const serialized = this.serializeIndexTree(this.props.indexTree);
		let outline;
		for (const i of serialized) {
			if (!outline && i.kind === ELearningKind.OUTLINE) {
				outline = i;
				continue;
			}
			if (outline && i.kind !== ELearningKind.OUTLINE) {
				this.props.setELearningTreeItem(i);
				break;
			}
		}
	};

	/**
	 * 受講対象が受講できませんダイアログのクローズハンドラ
	 */
	protected handleCloseCannotMoveItem = () => {
		this.setState({ openCannotMoveItem: false });
	};

	/**
	 * テキスト内のプレイヤー状態変更ハンドラ
	 */
	protected handleChangePlayerStatus = (playing: boolean) => {
		this.setState({ playerStatus: playing });
	};

	protected getNextTreeItemToTestForm = (): IIndexTreeItem | null => {
		return this.getNextTreeItem();
	};

	/**
	 * アンケート警告クローズハンドラ
	 */
	protected handleCloseNoticeGridQuestionnaire = () => {
		this.setState({ openNoticeGridQuestionnaire: false });
	};

	/**
	 * 課題警告クローズハンドラ
	 */
	protected handleCloseNoticeExercise = () => {
		this.setState({ openNoticeExercise: false });
	};

	/**
	 * ひとつ前のツリーアイテム検索
	 */
	protected getPrevTreeItem() {
		let { currentTreeItem } = this.props;
		const serialized = this.serializeIndexTree(this.props.indexTree);
		if (currentTreeItem && currentTreeItem.kind === ELearningKind.TESTLOG) {
			// テスト履歴の場合は現在地がテスト本体のようにふるまう
			for (const i of serialized) {
				if (i.id === currentTreeItem.testID) {
					currentTreeItem = i;
					break;
				}
			}
		}
		if (currentTreeItem) {
			let current: number;
			for (current = 1; current < serialized.length; current++) {
				if (serialized[current].id === currentTreeItem.id) {
					break;
				}
			}
			if (current < serialized.length) {
				return this.checkExpired(
					serialized,
					current,
					serialized.length,
					false
				);
			}
		}

		return null;
	}

	/**
	 * ひとつ後のツリーアイテム検索
	 */
	protected getNextTreeItem() {
		let { currentTreeItem } = this.props;
		const serialized = this.serializeIndexTree(this.props.indexTree);
		if (currentTreeItem && currentTreeItem.kind === ELearningKind.TESTLOG) {
			// テスト履歴の場合は現在地がテスト本体のようにふるまう
			for (const i of serialized) {
				if (i.id === currentTreeItem.testID) {
					currentTreeItem = i;
					break;
				}
			}
		}
		if (currentTreeItem) {
			let current: number;
			for (current = 0; current < serialized.length - 1; current++) {
				if (currentTreeItem.id === serialized[current].id) {
					break;
				}
			}

			if (current < serialized.length - 1) {
				return this.checkExpired(
					serialized,
					current,
					serialized.length,
					true
				);
			}
		}

		return null;
	}

	protected checkExpired(
		serialized: IIndexTreeItem[],
		current: number,
		total: number,
		isNext: boolean
	) {
		if (isNext) {
			for (current; current < total - 1; current++) {
				return serialized[current + 1];
			}
		} else {
			for (current; current > 0; current--) {
				return serialized[current - 1];
			}
		}

		return null;
	}
	/**
	 * 	インデックスツリーをナビゲーション順に並べる
	 * @param src
	 */
	protected serializeIndexTree(src: IIndexTreeItem[]) {
		const serialized = [] as IIndexTreeItem[];
		for (const item of src) {
			if (
				item.kind === ELearningKind.OUTLINE ||
				item.kind === ELearningKind.TEXT ||
				item.kind === ELearningKind.TEST ||
				item.kind === ELearningKind.ENQUETE ||
				item.kind === ELearningKind.SUBJECT ||
				item.kind === ELearningKind.SCORM
			) {
				serialized.push(item);
			}
			if (item.children) {
				for (const child of this.serializeIndexTree(item.children)) {
					serialized.push(child);
				}
			}
		}
		return serialized;
	}

	/**
	 * propsのfetchELearningProgressを利用して
	 * 最新の進捗率を取得する
	 */
	protected fetchELearningProgress() {
		return this.props.fetchELearningProgress(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			isPreview: this.props.preview,
			userId: this.props.userAttr.userId,
		});
	}
}

const TestConfirm: React.FC<{
	item: IIndexTreeItem;
	handleStart: () => void;
	handleClose: () => void;
	handleShowIndexTree: () => void;
	handleFinishELearning: () => void;
	showTree: boolean;
}> = props => {
	const testTitle = props.item ? props.item.testTitle : '';
	let tryCount = '';
	tryCount = i18n.t('Elearning_0032', { cnt: props.item.cnt });
	tryCount += props.item.retries
		? i18n.t('Elearning_0033', { retries: props.item.retries })
		: i18n.t('Elearning_0034');
	const timeLimit = props.item.timeLimit
		? i18n.t('Elearning_0035', { timeLimit: props.item.timeLimit })
		: i18n.t('Elearning_0002');
	if (props.showTree) {
		return (
			<Dialog
				open={true}
				onClose={props.handleClose}
				aria-labelledby="simple-dialog-title"
			>
				<DialogTitle id="alert-dialog-slide-title">
					{i18n.t('Elearning_0005')}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						{i18n.t('Elearning_0036')}
						<br />
						{i18n.t('Elearning_0037')}:{testTitle}
						<br />
						{i18n.t('Elearning_0038')}:{tryCount}
						<br />
						{i18n.t('Elearning_0039')}:{timeLimit}
						<br />
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={props.handleStart} color="primary">
						{i18n.t('Elearning_0019')}
					</Button>
					<Button onClick={props.handleShowIndexTree} color="primary">
						{i18n.t('Elearning_0009')}
					</Button>
					<Button
						onClick={props.handleFinishELearning}
						color="primary"
					>
						{i18n.t('Elearning_0011')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	} else {
		return (
			<Dialog
				open={true}
				onClose={props.handleClose}
				aria-labelledby="simple-dialog-title"
			>
				<DialogTitle id="alert-dialog-slide-title">
					{i18n.t('Elearning_0005')}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						{i18n.t('Elearning_0036')}
						<br />
						{i18n.t('Elearning_0037')}:{testTitle}
						<br />
						{i18n.t('Elearning_0038')}:{tryCount}
						<br />
						{i18n.t('Elearning_0039')}:{timeLimit}
						<br />
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={props.handleStart} color="primary">
						{i18n.t('Elearning_0019')}
					</Button>
					<Button
						onClick={props.handleFinishELearning}
						color="primary"
					>
						{i18n.t('Elearning_0011')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
};

const checkIsFirstTime = (indexTree: IIndexTreeItem[]): boolean => {
	for (const item of indexTree) {
		if (
			(item.iconClass && item.iconClass.search(/\-complete/) > -1) ||
			item.kind === 6 ||
			item.kind === 9
		) {
			return false;
		}
		if (item.children) {
			const isFirstTime = checkIsFirstTime(item.children);
			if (!isFirstTime) {
				return isFirstTime;
			}
		}
	}
	return true;
};

export const mapStateToProps = (state: IRootState) => ({
	admintFlg: state.eLearning.admintFlg,
	cnt: state.eLearning.cnt,
	currentPage: state.eLearning.currentPage,
	currentTreeItem: state.eLearning.currentTreeItem,
	explanationPage: state.eLearning.explanationPage,
	indexTree: state.eLearning.indexTree,
	lastLocation: state.eLearning.lastLocation,
	notMarkCompleteFlg: state.eLearning.notMarkCompleteFlg,
	reservedTreeItem: state.eLearning.reservedTreeItem,
	resumePage: state.eLearning.resumePage,
	resumeTopic: state.eLearning.resumeTopic,
	retries: state.eLearning.retries,
	scorm: state.eLearning.scorm,
	scormApi: state.eLearning.scormApi,
	showFinishDialog: state.eLearning.showFinishDialog,
	startTime: state.eLearning.startTime,
	status: state.eLearning.status,
	testTitle: state.eLearning.testTitle,
	timeLimit: state.eLearning.timeLimit,
	tsqId: state.eLearning.tsqId,

	token: state.session.token,
	userAttr: state.session.userAttr,

	elearingUpdateResult: state.eLearning.elearingUpdateResult,
	isFirst: state.eLearning.isFirst,

	mapParam: state.eLearning.mapParam,
	markAfter: state.eLearning.markAfter,
	requiredItemFlg: state.eLearning.requiredItemFlg,
	showTree: state.eLearning.showTree,

	nextBtnDisFlg: state.eLearning.nextBtnDisFlg,
	progressLoadingFlg: state.eLearning.progressLoadingFlg,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
	setNextBtnDisFlg: (nextBtnDisFlg: boolean) =>
		dispatch(setNextBtnDisFlg({ nextBtnDisFlg })),

	clearELearning: () => dispatch(clearELearning()),
	clearELearningReservedTreeItem: () =>
		dispatch(clearELearningReservedTreeItem()),
	clearImstat: () => dispatch(clearImstat()),
	closeIndexTree: () => dispatch(openELearningIndexTree({ isOpen: false })),
	fetchAdmintCompleteModel: (
		token: string,
		arg: IStartELearningTextParam
	) => {
		const s = ScenarioFactory.createAdmintCompleteModel(dispatch, token);
		return s.run(arg);
	},
	fetchELearningProgress: (
		token: string,
		arg: IFetchELearningProgressParam
	) => {
		const s = ScenarioFactory.createFetchELearningProgress(dispatch, token);
		return s.run(arg);
	},
	fetchELearningTop: (token: string, arg: IFetchELearningTopParam) => {
		const s = ScenarioFactory.createFetchELearningTop(dispatch, token);
		return s.run(arg);
	},
	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ScenarioFactory.createFetchELearningTree(dispatch, token);
		s.run(arg);
	},

	/**
	 * コンテンツ終端に到達: ダイアログ処理()
	 */
	handleEndOfContent: async () => {
		dispatch(showELearningFinishDialog({ isOpen: true }));
	},

	issueELearningReservedTreeItem: () =>
		dispatch(issueELearningReservedTreeItem({})),
	nextTree: (token: string, arg: INextTreeParam) => {
		const s = ScenarioFactory.createNextTree(dispatch, token);
		s.run(arg);
	},
	openELearningIndexTree: () =>
		dispatch(openELearningIndexTree({ isOpen: true })),
	pushHistory: (path: string) => dispatch(push(path)),
	setELearningPage: (page: number) => dispatch(setELearningPage({ page })),
	setELearningReservedTreeItem: (item: IIndexTreeItem) =>
		dispatch(setELearningReservedTreeItem({ item })),
	setELearningTreeItem: (item: IIndexTreeItem | null) =>
		dispatch(setELearningTreeItem({ item })),
	showELearningByBookmark: (topic: string, page: number) =>
		dispatch(
			showELearningByBookmark({
				page,
				topicID: topic,
			})
		),
	showELearningFinishDialog: (isOpen: boolean) =>
		dispatch(showELearningFinishDialog({ isOpen })),

	setELearningNextOrTopITem: () => dispatch(setELearningNextOrTopITem({})),

	getScoringButtonClickResult: (elearingUpdateResult: undefined) =>
		dispatch(getScoringButtonClickResult({ elearingUpdateResult })),
	setNotMarkCompleteFlg: () => dispatch(setNotMarkCompleteFlg()),
	setShowTree: (showTree: boolean) => dispatch(setShowTree({ showTree })),

	resetELearningPage: () => dispatch(resetELearningPage({})),

	/**
	 * 受講画面が読み込みの状態表示制御設定イベント
	 */
	setProgressLoadingFlg: (progressLoadingFlg: boolean) =>
		dispatch(setProgressLoadingFlg({ progressLoadingFlg })),

	/**
	 * コンポーネント更新イベント
	 */
	updated: (params: Parameters<typeof elearningComponentUpdated>[0]) =>
		dispatch(elearningComponentUpdated(params)),
});

export interface IELearningProps extends IELearningCommonProps {
	state: IELearningPushState;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IELearningProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ELearningComponent);

const ELearning = withStyles(styles)(Connected);

export default ELearning;



// WEBPACK FOOTER //
// ./src/containers/ELearning.tsx